import React from "react";
import CardArticles from "../components/CardArticles";

class Articles extends React.Component {
  render() {
    return (
      <>
        <div className="container pt-4 pb-4 content-detail">
          <h1 className="font-PoppinsBold pb-3">
            This articles Area <span className="font-green"></span>
            <span className="font-green"> please dont hate 😅</span> , just have
            fun.
          </h1>
          <div className="nav-content shadow-sm p-3 mb-5">
          <div className="col-12 isi-content position-relative">
            <CardArticles />
          </div>
        </div>
        </div>
      </>
    );
  }
}

export default Articles;
